import * as React from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { cn } from '@companion-professional/webutils';
import { Check } from 'lucide-react';

// DropdownMenuCheckboxItem is a checkbox item that can be checked or unchecked.  This can be used for toggling on/off
// various settings from inside a dropdown menu.
// Key Parameters:
//   checked: boolean - whether or not the checkbox is checked
//   onCheckedChange: (checked: boolean) => void - callback for when the checkbox is checked or unchecked
export const DropdownMenuCheckboxItem = React.forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.CheckboxItem>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.CheckboxItem>
>(({ className, children, checked, ...props }, ref) => (
  <DropdownMenuPrimitive.CheckboxItem
    ref={ref}
    className={cn(
      'relative',
      'flex',
      'cursor-default',
      'select-none',
      'items-center',
      'rounded-md',
      'py-1.5',
      'pl-8',
      'pr-2',
      'text-md',
      'outline-none',
      'transition-colors',
      'focus:bg-accent',
      'focus:text-on-accent',
      'cursor-pointer',
      'data-[disabled]:pointer-events-none',
      'data-[disabled]:opacity-50',
      className
    )}
    checked={checked}
    {...props}
  >
    <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
      <DropdownMenuPrimitive.ItemIndicator>
        <Check className="h-4 w-4" />
      </DropdownMenuPrimitive.ItemIndicator>
    </span>
    {children}
  </DropdownMenuPrimitive.CheckboxItem>
));
DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
